export default "__VITE_ASSET__Bhv3AcGC__"